export default __webpack_public_path__ + "static/illustration-action.url-3d3ae8104e2ada6f19362294f938c1dd.svg";